@if (splash) {
  <div @splashFade class="splash-screen">
    <img
      id="splash-logo"
      fxFlex="none"
      src="assets/images/hubtype-logo-spash.svg"
    />
    <h1>Starting...</h1>
  </div>
}
